(function ( $ ) {

    $(document).on('ready', function () {

        if ( typeof lightGallery !== "undefined") {

            var galleriesArr = [];

            $('.my-gallery__grid').each(function () {
                var $this = $(this);
                var dataArray = $this.data('gallery-items');

                if ( typeof dataArray !== "undefined" && dataArray !== '' ) {

                    // sanitizing urls
                    dataArray.forEach(function (currentItem) { currentItem.src = currentItem.src.replace(/([&'’"«»“”@#%?=~_|!,();])/g, ''); });

                    galleriesArr.push({
                        'galleryId': $this.attr('id'),
                        'gallery': lightGallery($(this)[0], {
                            licenseKey: '0000-0000-000-0000',
                            download: false,
                            dynamic: true,
                            dynamicEl: dataArray,
                            pager: true
                        })
                    });
                }
            });

            // console.log(galleriesArr);

            $('.gallery-open').on('click', function () {
                var galleryId = $(this).data('my-gallery-id');
                if ( galleryId && galleriesArr ) {
                    galleriesArr.forEach(function (galleryItem) {
                        if ( galleryItem.galleryId === galleryId ) galleryItem.gallery.openGallery();
                    });
                }
            });

        }

    });

})( jQuery )